(function () {
  const duration = 5 * 60 * 1000;
  let deadline = 0;
  let wasOpen = false;
  let lastBanner = null;

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function animateBanner(banner) {
    if (!banner) return;
    banner.classList.remove('is-active');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (banner.isConnected) banner.classList.add('is-active');
      });
    });
  }

  function reset() {
    deadline = Date.now() + duration;
    animateBanner(document.querySelector('[data-zaveli-cart-top]'));
    render();
  }

  function render() {
    const banner = document.querySelector('[data-zaveli-cart-top]');
    const open = drawer()?.classList.contains('active') || false;
    if (open && !wasOpen) {
      wasOpen = true;
      reset();
      return;
    }
    wasOpen = open;
    if (!banner) return;

    if (banner !== lastBanner) {
      lastBanner = banner;
      if (open) animateBanner(banner);
    }

    const counter = banner.querySelector('[data-zaveli-cart-countdown]');
    if (!counter) return;
    if (!deadline) {
      counter.textContent = '05:00';
      return;
    }
    if (deadline <= Date.now()) {
      reset();
      return;
    }

    const remaining = Math.ceil((deadline - Date.now()) / 1000);
    counter.textContent = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0');
  }

  document.addEventListener('cart:updated', reset);

  function init() {
    const cartDrawer = drawer();
    if (cartDrawer && window.MutationObserver) {
      new MutationObserver(render).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }
    render();
    window.setInterval(render, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

